import getConfig from 'next/config';

const url = require('url');
const queryString = require('querystring');

const contentURLMapper = (rawUrl, isHead = false, featureFlags = []) => {
  const { publicRuntimeConfig } = getConfig();
  const { appEnv } = publicRuntimeConfig;
  const contentBasePath = 'content-renderer';
  const parsedUrl = url.parse(rawUrl);
  const pathName = parsedUrl.pathname;
  const plainQueryString = parsedUrl.query;
  const parsedQueryString = queryString.parse(plainQueryString);
  const id = pathName && pathName !== '/' ? pathName : '/homepage';

  const pathWithoutTrailingSlash = pathName.endsWith('/')
    ? pathName.substr(0, pathName.length - 1)
    : pathName;

  let featureFlagParam = '';
  if (featureFlags && featureFlags.length !== 0) {
    const featureFlagsString = JSON.stringify(featureFlags);
    const parsedfeatureFlagsString = encodeURIComponent(featureFlagsString);
    featureFlagParam = `&featureFlags=${parsedfeatureFlagsString}`;
  }

  const appEnvParam = appEnv ? `&appEnv=${appEnv}` : '';
  if (isHead) {
    const { section } = parsedQueryString;
    const sectionParams = section ? `section=${section}&` : ``;
    return pathWithoutTrailingSlash === ''
      ? '/content-renderer/homepage.head'
      : `/content-renderer${pathWithoutTrailingSlash}.head?${sectionParams}includeMetadata=true`;
  } else {
    return plainQueryString
      ? `/${contentBasePath}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false&${plainQueryString}${featureFlagParam}${appEnvParam}`
      : `/${contentBasePath}${id}?experimentsEnabled=true&includeCoreJS=false&includePolyfills=false${featureFlagParam}${appEnvParam}`;
  }
};

export default contentURLMapper;
